import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ObservationCardBody from './ObservationCardBody';
import OrientationCardBody from './OrientationCardBody';
import './TrainingPhaseCard.scss';
import Checkbox from "../../../shared/forms/Checkbox";
import TrainingPhaseUploads from "../uploads/TrainingPhaseUploads";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import DatePicker from 'react-datepicker';
import 'react-datepicker/src/stylesheets/datepicker.scss';
import {formatDate} from "../../../shared/services/utils/utils";
import oitsActions from '../../store/oits/action-creators/index';
import moment from 'moment';
import SignActorsManage from "./SignActorsManage";
import Modal from "../../../shared/ui/Modal";
import oitsActionCreators from "../../store/oits/action-creators/oits";
import CustomForm from "../../../shared/components/form/CustomForm";
import {Badge} from "reactstrap";
import classNames from 'classnames'
import OitSummaryPage from "../reports/OitSummaryPage";

class TrainingPhaseCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: props.phase.scheduledTo ? moment(props.phase.scheduledTo) : null,
      showSignActorsModal: false,
      showEditHoursDialog: false,
      showOitSummaryReportDialog: false,
      phaseUploadsVersion: 0
    };

  }

  // ----------------------
  // Computed
  // ----------------------

  get canPhaseOpen() {
    return !!this.props.nextPendingPhase;
  }

  get isClosedOrCompleted() {
    return (
      this.props.phase.status === 'closed' ||
      this.props.phase.status === 'completed'
    );
  }

  get canReopenPhase() {
    return (
      this.props.userContext.hasScope(['ftoc', 'sup']) &&
      this.props.phase.status === 'completed'
    );
  }

  get canSeeStartDateBtn() {
    return this.props.userContext.hasScope(['ftoc', 'sup']) && this.props.phase.status === 'pending';
  }

  get showPhaseActions() {
    return (
      this.props.userContext.hasScope(['ftoc', 'sup']) && !this.isClosedOrCompleted
    );
  }

  get hasTaskGroups() {
    return this.props.taskGroups && this.props.taskGroups.filter(taskGroup => {
      return taskGroup.phase && taskGroup.phase.name === this.props.phase.header;
    }).length;
  }

  get isPhaseOpened() {
    return this.props.phase.status === 'opened'
      || this.props.phase.status === 'remedial';
  }

  get canViewReport() {
    return this.isPhaseOpened
      || (this.props.phase.status !== 'pending')
  }

  get selectedOit() {
    if (this.state.showSignActorsModal) {
      return this.props.selectedOit;
    }

    return null;
  }

  handleDateChange(date, phaseId) {
    this.setState({
      selectedDate: date
    });


    this.props.savePhaseStartDate(date.toISOString(), phaseId);
  }

  setFlowActorsForTrainingTracker() {
    this.setState({
      showSignActorsModal: true
    })
  }

  closeSignFlowManage() {
    this.setState({
      showSignActorsModal: false
    })
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div key={this.props.phase.guid + 'timeline'} className="timeline-item training-phase-card">
        <div className="timeline-item-header">{this.props.phase.header}</div>
        <div className="card mb-3 timeline-item-content">
          <div className="card-header timeline-item-actions">
            {this.showPhaseActions ? (
              <Fragment>
                {!this.isPhaseOpened ? (
                  <button
                    className="button small primary"
                    disabled={!this.canPhaseOpen}
                    onClick={() =>
                      this.props.onOpenPhase(this.props.phase.guid)
                    }
                  >
                    <i className="fa fa-play-circle" />
                    <span>Start Phase</span>
                  </button>
                ) : (
                  <button
                    className="button small delete"
                    //disabled={!this.props.phase.getCanPhaseClose()}
                    onClick={() =>
                      this.props.onClosePhase(this.props.phase.guid)
                    }
                  >
                    <i className="fa fa-power-off" />
                    <span>Complete Phase</span>
                  </button>
                )}

                {this.props.phase.type === 'observation' && (
                  <Fragment>
                    {this.props.phase.getCanAssignFto() ? (
                      <button
                        className="button small primary"
                        onClick={() =>
                          this.props.onAssignFto(this.props.phase.guid)
                        }
                      >
                        <i className="fa fa-hand-pointer-o" />
                        <span>Assign {this.props.ftoShortLabel}</span>
                      </button>
                    ) : (
                      <button
                        className="button small secondary"
                        onClick={() =>
                          this.props.onUnassignFto(this.props.phase.guid)
                        }
                      >
                        <i className="fa fa-minus-circle" />
                        <span>Unassign {this.props.ftoShortLabel}</span>
                      </button>
                    )}
                  </Fragment>
                )}
              </Fragment>
            ): this.isPhaseOpened ? (
                <Badge color={'danger'}>OPENED</Badge>
            ): (
              <Badge color={'primary'}>{this.props.phase.status}</Badge>
            )}

            {this.canViewReport && (
              <div className="view-reports">
                <button
                  className={classNames("button small", {'primary': !this.isPhaseOpened, 'danger': this.isPhaseOpened})}
                  onClick={() => this.props.onViewPhase(this.props.phase.guid)}
                >
                  <span>View reports</span> &nbsp;
                  <i className="fa fa-angle-right" />
                </button>
              </div>
            )}

            {this.canReopenPhase ? (
              <button
                className="button small primary"
                onClick={() =>
                  this.props.onReopenPhase(this.props.phase.guid)
                }
              >

                <i className="fa fa-play-circle" />
                <span>Reopen Phase</span>
              </button>
            ): null}
          </div>

          <div className="end-date-container">
            {this.props.phase.type === 'observation' && this.showPhaseActions &&
              <div className="risk-alerts">
                <Checkbox
                  label={'Risk alerts'}
                  onChange={(event) => this.props.onHasRiskALertsChange(event.target.checked)}
                  checked={this.props.phase.hasRiskAlert}/>
              </div>
            }

            {this.props.userContext.hasScope(['ftoc', 'sup', 'cstaff', 'depadmin', 'admin']) && <button
              className="button secondary small"
              onClick={() => this.setState({showEditHoursDialog: true})}>
              Edit hours <i>({this.props.phase.hours ? this.props.phase.hours + 'h' : 'Not set'})</i>
            </button>}

            {this.props.userContext.hasScope(['cstaff', 'depadmin', 'admin']) && <button
              className="button secondary small"
              onClick={() => this.setState({showOitSummaryReportDialog: true})}>
              EOP Report (BETA)
            </button>}

            <button
              className="button secondary small"
              onClick={() => this.setFlowActorsForTrainingTracker()}>
              Sign actors
            </button>

            {this.canSeeStartDateBtn &&
              <DatePicker
                key={this.props.phase.guid  + 'datepicker'}
                selected={this.state.selectedDate}
                onChange={date => this.handleDateChange(date, this.props.phase.guid)}
                customInput={
                  <div>
                    <button className="button secondary small">
                      <i className="fa fa-edit"/>
                      <span>Phase start date</span>

                      {this.state.selectedDate &&
                        <span className="date-format">{formatDate(this.state.selectedDate)} </span>
                      }

                    </button>
                  </div>
                }
              />
            }
            {!this.canSeeStartDateBtn && this.state.selectedDate && (
              <div key={this.props.phase.guid  + 'start-date'}>
                <button className="button secondary small">
                  <span>Phase start date</span>
                  {this.state.selectedDate &&
                    <span className="date-format">{formatDate(this.state.selectedDate)} </span>
                  }
                </button>
              </div>
            )}
          </div>

          <div className="card-body timeline-item-body">
            {this.props.phase.type === 'observation' ? (
              <ObservationCardBody key={this.props.phase.type + this.props.phase.guid + 'card-body'} phase={this.props.phase} isPhaseOpen={this.isPhaseOpened}/>
            ) : (
              <OrientationCardBody key={this.props.phase.type + this.props.phase.guid + 'card-body'} phase={this.props.phase} isPhaseOpen={this.isPhaseOpened}/>
            )}
          </div>
          <TrainingPhaseUploads key={this.props.phase.guid  + 'uploads' + this.state.phaseUploadsVersion} trainingPhaseGuid={this.props.phase.guid}/>
        </div>

        <Modal
          isOpen={!!this.selectedOit}
          onClose={() => this.closeSignFlowManage()}
          size="lg"
          title={'Set approvers'}>
          {this.selectedOit
          && <SignActorsManage
            oit={this.selectedOit}
            phase={this.props.phase}
            onSignActorsUpdate={(signActors) => this.props.updateSignActorsForPhase(signActors, this.props.phase.guid)}/>}
        </Modal>

        <Modal
          isOpen={this.state.showEditHoursDialog}
          title={'Edit phase total hours'}
          onClose={() => this.setState({showEditHoursDialog: false})}
        >
          {this.state.showEditHoursDialog && (
            <CustomForm
              config={{
                fields: {
                  hours: {
                    type: 'number',
                    label: 'Phase hours'
                  }
                }
              }}
              initialValues={this.props.phase}
              onSubmit={({hours}) => this.props.updateHoursForPhase(hours === '' ? null : hours, this.props.phase.guid).then(() => this.setState({showEditHoursDialog: false}))}
            />
          )}
        </Modal>

        <Modal
          isOpen={this.state.showOitSummaryReportDialog}
          title={'Phase summary'}
          onClose={() => this.setState({showOitSummaryReportDialog: false})}
          fullscreen={false}
          size="lg"
        >
          {this.state.showOitSummaryReportDialog && (
            <OitSummaryPage
              oit={this.props.selectedOit}
              phase={this.props.phase}
              onSaved={() => this.setState(prevState => ({phaseUploadsVersion: prevState.phaseUploadsVersion + 1}))}
            />
          )}
        </Modal>
      </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    taskGroups: state.tasks.taskGroups,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    savePhaseStartDate: (scheduledAt, trainingPhaseGuid) => {
      return dispatch(oitsActions.savePhaseStartDate(scheduledAt, trainingPhaseGuid));
    },
    updateSignActorsForPhase: (signActors, trainingTrackerGuid) => {
      return dispatch(oitsActionCreators.updateSignActorsForPhase(signActors, trainingTrackerGuid))
    },
    updateHoursForPhase: (hours, trainingTrackerGuid) => {
      return dispatch(oitsActionCreators.updateHoursForPhase(hours, trainingTrackerGuid))
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingPhaseCard);
